import {ReducerBuilder} from "@cuatroochenta/co-redux-builders";
import LawType from "../../../../commons/model/LawType";
import TaskLawTypeDetail from "../../../../commons/ws/lawType/TaskLawTypeDetail";
import LawTypeFormAdminScreenActions from "./LawTypeFormAdminScreenActions";

interface InitialState {
    lawTypeLoading: boolean,
    lawType?: LawType,
}

const INITIAL_STATE: InitialState = {
    lawTypeLoading: false,
    lawType: undefined,
};

export default ReducerBuilder.newBuilder(INITIAL_STATE)
    .onEvent(TaskLawTypeDetail.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState) => ({
        ...oldState,
        lawTypeLoading: true
    }))
    .onEvent(TaskLawTypeDetail.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState) => ({
        ...oldState,
        lawTypeLoading: false
    }))
    .onEvent(TaskLawTypeDetail.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return { ...oldState, lawType: payload.data};
        })

    .onEvent(LawTypeFormAdminScreenActions.clearReducer, () => INITIAL_STATE)

    .build();
